import { FC, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isEqual, isNil } from 'lodash';
import { useInfoContext } from '../contexts/InfoContext/infoContext';
import { floorPlansState, selectedFloorPlanState } from '../recoil/atoms';

export const MapEffects: FC = () => {
  const { openSnackbar } = useInfoContext();
  const floorPlans = useRecoilValue(floorPlansState);
  const setSelectedFloorPlan = useSetRecoilState(selectedFloorPlanState);

  useEffect(() => {
    setSelectedFloorPlan(prev => {
      const floorPlanData = floorPlans.find(x => x.id === prev?.id) ?? null;
      if (isNil(prev) || isEqual(prev, floorPlanData)) {
        return prev;
      }

      if (isNil(floorPlanData)) {
        openSnackbar({ title: 'The selected Floor Plan is no longer available. Returning to main map.', type: 'WARN' });
      }

      return floorPlanData;
    });
  }, [floorPlans]);

  return <></>;
};
